module.exports = __webpack_public_path__ + "static/media/tree-icon-outline.0a0ad33b.svg";